import {initTomSelectInput} from "../tom-select/tom-select";
// noinspection ES6UnusedImports
import TomSelect from "tom-select";

/**
 * @param domElement
 * @param {import('tom-select/dist/types/types/index').TomSettings|Object} settings - Tom Select settings object
 * @return {TomSelect}
 */
function initShirtSizeInput(domElement, settings = {
	create: true,
	allowEmptyOption: true,
	maxItems: 1,
	dropdownParent: 'body', // This ensures the dropdown is appended to body
	render: {
		dropdown: function () {
			// Set a higher z-index than SweetAlert's modal (which is typically 1060)
			return '<div class="ts-dropdown" style="z-index: 1061"></div>';
		}
	}


}) {
	// Set options
	settings.options = getUsShirtSizes().map(size => {
		return {
			value: size,
			text: size,
		}
	});

	// Add preselected value if not in array already
	if (domElement.value && !settings.options.find(option => option.value === domElement.value)) {
		settings.options.push({
			value: domElement.value,
			text: domElement.value,
		})

	}

	initTomSelectInput(domElement, settings);
}


/**
 * @return {string[]} - Array of common US shirt sizes ordered from smallest to largest
 */
function getUsShirtSizes() {
	return ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
}


export {initShirtSizeInput}
